import React from 'react'

import './star-rating.css'

const ratingToPercent = decimal => decimal * 10

const StarRating = ({rating, className}) => {
  return (
    <div className={`star-ratings-css ${className}`}>
      <div className='star-ratings-css-top' style={{width: ratingToPercent(rating)}}>
        <span>★</span>
        <span>★</span>
        <span>★</span>
        <span>★</span>
        <span>★</span>
      </div>
      <div className='star-ratings-css-bottom'>
        <span>★</span>
        <span>★</span>
        <span>★</span>
        <span>★</span>
        <span>★</span>
      </div>
    </div>
  )
}

StarRating.defaultProps = {
  rating: 10
}

export default StarRating



// WEBPACK FOOTER //
// ./src/components/Modal/ModalItem/components/StarRating/index.js